import { Button, CircularProgress, Divider, FormControlLabel, FormGroup, Switch, TextField, Typography, Icon, IconButton } from '@material-ui/core'
import { useValues } from 'hooks'
import { createRejectionCauseService, editRejectionCauseService, EDIT_PATH, FIELDS } from 'lib'
import React from 'react'
import { useLocation, useHistory } from 'react-router'
import { IRejectionCause } from 'types'

interface Props {
    onSuccess: () => void
    onError: () => void
    onClose: () => void
}

const RejectionCauseForm = (props: Props) => {
    const location = useLocation()
    const history = useHistory()
    const { onError, onSuccess, onClose } = props
    const initialInput = React.useRef<any>(null)
    const [loading, setLoading] = React.useState<boolean>(false)
    const { values: rejectionCause, updateValue: handleChange, updateValues } = useValues()
    const handleSumbit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        try {
            setLoading(true)
            if (!(location.state as any)?.edit) {
                await createRejectionCauseService({ ...rejectionCause, active: true })
            } else {
                const edited = { ...rejectionCause }
                delete edited[FIELDS.rejectionCauseId.key]
                await editRejectionCauseService(rejectionCause[FIELDS.rejectionCauseId.key], { ...edited })
            }
            setLoading(false)
            if (!(location.state as any)?.edit) {
                updateValues({ name: "", description: "", rejectionCauseCode:0, active: true } as IRejectionCause)
                initialInput.current?.focus()
            }
            onSuccess()
        } catch (error) {
            setLoading(false)
            onError()
        }
    }
    React.useEffect(() => {
        if ((location.state as any)?.edit) {
            if ((location.state as any)?.values) {
                updateValues((location.state as any)?.values)
            }
        }
        else {
            history.replace(location.pathname.replace(EDIT_PATH, ""))
        }
    }, [location.state, updateValues, history, location.pathname])
    return (
        <div className="p-4">
            <div className="flex items-center justify-between">
                <Typography variant="body2" style={{ fontWeight: 600, letterSpacing: 0.5 }}>
                    {(location.state as any)?.edit ? "Editar Motivo de Rechazo" : "Nuevo Motivo de Rechazo"}
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <Icon fontSize="small">close</Icon>
                </IconButton>
            </div>
            <form onSubmit={handleSumbit} className="pt-4 flex flex-col" style={{ width: 300 }}>
                <TextField
                    inputRef={initialInput}
                    autoFocus
                    size="small"
                    label={FIELDS.rejectionCauseCode.name}
                    variant="outlined"
                    fullWidth
                    required
                    value={rejectionCause[FIELDS.rejectionCauseCode.key]}
                    onChange={(e) => handleChange(FIELDS.rejectionCauseCode.key, e.target.value)}
                />
                <TextField
                    inputRef={initialInput}
                    size="small"
                    label={FIELDS.name.name}
                    variant="outlined"
                    fullWidth
                    style={{ marginTop: 10 }}
                    required
                    value={rejectionCause[FIELDS.name.key]}
                    onChange={(e) => handleChange(FIELDS.name.key, e.target.value)}
                />
                <TextField
                    size="small"
                    label={FIELDS.description.name}
                    variant="outlined"
                    fullWidth
                    style={{ marginTop: 10 }}
                    multiline
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault() } }}
                    rows={3}
                    required
                    value={rejectionCause[FIELDS.description.key]}
                    onChange={(e) => handleChange(FIELDS.description.key, e.target.value)}
                />
                {
                    (location.state as any)?.edit &&
                    <FormGroup className="p-2" row>
                        <FormControlLabel
                            control={<Switch color="primary" size="small" checked={Boolean(rejectionCause[FIELDS.active.key])} onChange={(e) => handleChange(FIELDS.active.key, e.target.checked)} name={FIELDS.active.name} />}
                            label={FIELDS.active.name}
                        />
                    </FormGroup>
                }
                <p>{rejectionCause[FIELDS.active.key]}</p>
                <div className="mt-4">
                    <Divider />
                </div>
                <div className="flex justify-end pt-3">
                    <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        disableElevation
                        disabled={loading}
                        type="submit"
                    >
                        {loading ? <CircularProgress style={{ color: "white" }} size={16} className="my-1" thickness={10} /> : (location.state as any)?.edit ? "Guardar" : "Registrar"}
                    </Button>
                </div>
            </form>
        </div>
    )
}

export default RejectionCauseForm
